namespace TabAurous.Purchase {
    export namespace ApprovalInReturnAPIService {
        export const baseUrl = '~/api/Purchase/ApprovalInReturnAPI';

        export declare function Create(request: Serenity.SaveRequest<ApprovalInReturnRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ApprovalInReturnRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ApprovalInReturnRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<ApprovalInReturnRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "~/api/Purchase/ApprovalInReturnAPI/Create",
            Update = "~/api/Purchase/ApprovalInReturnAPI/Update",
            Delete = "~/api/Purchase/ApprovalInReturnAPI/Delete",
            Retrieve = "~/api/Purchase/ApprovalInReturnAPI/Retrieve",
            List = "~/api/Purchase/ApprovalInReturnAPI/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ApprovalInReturnAPIService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
